import { useEffect, useState } from 'react';

import consumer from '../../channels/consumer';

export default (channel, userId, processoAno) => {
  const [connected, setConnected]       = useState(false);
  const [disconnected, setDisconnected] = useState(false);
  const [received, setReceived]         = useState(null);

  useEffect(() => {
    consumer.subscriptions.create({channel, user_id: userId, processo_ano: processoAno}, {
      connected:    () => setDisconnected(false) && setConnected(true),
      disconnected: () => setConnected(false) && setDisconnected(true),
      received:     (data) => setReceived(data)
    });
  }, [channel, userId, processoAno]);

  return {connected, disconnected, received};
};
